import React, { Component } from "react";
import PropTypes from "prop-types";
import MenuKit from "../../../../components/kit/Menu/MenuKit";
import { debounce, safePropValueOr } from "../../../../helpers/common";

import {
  FieldTypeAndSelectInputKitSD,
  FieldTypeAndSelectPopupOptionIconSD,
  FieldTypeAndSelectPopupOptionInnerSD,
  FieldTypeAndSelectPopupOptionSD,
  FieldTypeAndSelectPopupOptionTextSD,
  FieldTypeAndSelectPopupSD,
  FieldTypeAndSelectSD
} from "./styled";
import IconThreeDots from "../../../../components/kit/Icon/IconThreeDots";
import ButtonIconKit from "../../../../components/kit/ButtonIcon/ButtonIconKit";

class FieldTypeAndSelect extends Component {
  static propTypes = {
    /** pass the search word. Should return Promise with array of options*/
    onSearch: PropTypes.func.isRequired,
    /** pass selected options */
    onChange: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func,
    /** selected options*/
    selectedOption: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    defaultOptions: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      })
    ),
    onBlur: PropTypes.func,
    placeholder: PropTypes.string,
    hasError: PropTypes.bool,
    noResultText: PropTypes.node,
    readOnly: PropTypes.bool,
    icon: PropTypes.node,
    searchWord: PropTypes.string,
    showItemId: PropTypes.bool,
    skipKeys: PropTypes.arrayOf(PropTypes.string)
  };

  static defaultProps = {
    defaultOptions: [],
    searchWord: "",
    noResultText: "0 Results found",
    showItemId: false,
    skipKeys: []
  };

  state = {
    searchWord: safePropValueOr(this.props, "selectedOption.label", ""),
    options: this.props.defaultOptions,
    isPopupOpen: false
  };

  componentDidMount() {
    this.debouncedSearchOptions = debounce(this.searchOptions, 300);
    this.searchOptions();
  }

  componentDidUpdate(prevProps, prevState, s) {
    const { selectedOption } = this.props;
    if (
      JSON.stringify(prevProps.selectedOption) !==
        JSON.stringify(selectedOption) &&
      selectedOption
    ) {
      this.setState({ searchWord: selectedOption.label }, this.searchOptions);
    }
  }

  isValueSelected = () => {
    return !!this.props.selectedOption;
  };

  handleBlurSearchWord = () => {
    setTimeout(() => {
      const { onBlur } = this.props;

      this.setState({ isPopupOpen: false });
      if (typeof onBlur === "function") {
        onBlur();
      }
    }, 200); // todo: for fast fix that popup is hidden before click was fired
  };

  handleFocusSearchWord = () => {
    this.setState({ isPopupOpen: true });
  };

  handleChangeSearchWord = e => {
    let searchWord = e.target.value;

    if (this.props.skipKeys.length > 0) {
      searchWord =
        this.props.skipKeys.indexOf(searchWord) > -1 ? "" : searchWord;
    }

    const optionWithSearchWordInLabel =
      this.state.options.find(opt => opt.label === searchWord) || null;

    this.props.onChange(optionWithSearchWordInLabel);
    this.setState({ searchWord }, this.debouncedSearchOptions());
  };

  handleSelectOption = (option, notSelect) => {
    this.setState({ searchWord: "", selectedOption: { ...option } });
    this.props.onChange(option, notSelect);
  };

  handleOnKeyDown = e => {
    this.props.onKeyDown &&
      this.props.onKeyDown(e, () => this.setState({ searchWord: "" }));
  };

  searchOptions = () => {
    this.props.onSearch(this.state.searchWord).then(options => {
      this.setState({ options });
    });
  };

  renderOptions = () => {
    const { options, isPopupOpen } = this.state;
    const { noResultText, icon, showItemId, onShowPopup } = this.props;

    if (!isPopupOpen) return null;

    return (
      <FieldTypeAndSelectPopupSD>
        {options.length ? (
          <MenuKit items={options} propNameForText={"label"}>
            {item => (
              <FieldTypeAndSelectPopupOptionSD
                onClick={() => this.handleSelectOption(item)}
              >
                <FieldTypeAndSelectPopupOptionInnerSD>
                  <FieldTypeAndSelectPopupOptionTextSD iconAfter={!!icon}>
                    <span>
                      <span>{item.label}</span>
                      {showItemId && item.id && <span>ID:{item.id}</span>}
                    </span>
                  </FieldTypeAndSelectPopupOptionTextSD>
                  {icon && (
                    <FieldTypeAndSelectPopupOptionIconSD>
                      {" "}
                      {icon}{" "}
                    </FieldTypeAndSelectPopupOptionIconSD>
                  )}
                  {typeof onShowPopup === "function" && (
                    <ButtonIconKit
                      width={12}
                      height={20}
                      onClick={async e => {
                        e.stopPropagation();
                        const notSelect = await onShowPopup(item);
                        this.handleSelectOption(item, notSelect);
                      }}
                    >
                      <IconThreeDots width={4} />
                    </ButtonIconKit>
                  )}
                </FieldTypeAndSelectPopupOptionInnerSD>
              </FieldTypeAndSelectPopupOptionSD>
            )}
          </MenuKit>
        ) : (
          <FieldTypeAndSelectPopupOptionSD>
            <FieldTypeAndSelectPopupOptionTextSD>
              {noResultText}
            </FieldTypeAndSelectPopupOptionTextSD>
            {}
          </FieldTypeAndSelectPopupOptionSD>
        )}
      </FieldTypeAndSelectPopupSD>
    );
  };

  render() {
    return (
      <FieldTypeAndSelectSD>
        <FieldTypeAndSelectInputKitSD
          disabled={this.props.readOnly}
          ref={this.inputRef}
          onBlur={this.handleBlurSearchWord}
          onFocus={this.handleFocusSearchWord}
          onChange={this.handleChangeSearchWord}
          value={this.state.searchWord}
          isSelected={this.isValueSelected()}
          placeholder={this.props.placeholder}
          hasError={this.props.hasError}
          onKeyDown={this.handleOnKeyDown}
        />

        {this.renderOptions()}
      </FieldTypeAndSelectSD>
    );
  }
}

export default FieldTypeAndSelect;
